import Chip from "@mui/material/Chip";
export const StatusChip = ({ value }) => {
  const color =
    value == "online"
      ? "success"
      : value == "offline"
      ? "error"
      : value == "pending"
      ? "warning"
      : "default";

  return <Chip label={value} color={color} size="small" variant="outlined" />;
};
